import { render, staticRenderFns } from "./SocsoCalculator.vue?vue&type=template&id=2a8e2dfc&scoped=true"
import script from "./SocsoCalculator.vue?vue&type=script&lang=js"
export * from "./SocsoCalculator.vue?vue&type=script&lang=js"
import style0 from "./SocsoCalculator.vue?vue&type=style&index=0&id=2a8e2dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8e2dfc",
  null
  
)

export default component.exports